import React, { type PropsWithChildren } from 'react';

import { RowWrapper } from './styled';

type RuleItemRowProps = PropsWithChildren<{
	className?: string;
}>;

export const RuleItemRow = ({ children, className }: RuleItemRowProps) => {
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
	return <RowWrapper className={className}>{children}</RowWrapper>;
};
